import React, { FunctionComponent } from "react";
import { useTheme } from "@mui/material";
import { Theme } from "@emotion/react";

export const DotSvgComponent: FunctionComponent = () => {
    const theme = useTheme<Theme>();
    const dotsGeomPoints = [
        { x: 10, y: 20 },
        { x: 20, y: 60 },
        { x: 45, y: 45 },
        { x: 65, y: 18 },
        { x: 80, y: 60 },
        { x: 120, y: 30 },
        { x: 130, y: 45 },
    ];
    return (
        <svg height="100%" width="100%" viewBox="0 0 150 100">
            {dotsGeomPoints.map(({ x, y }, index) => (
                <circle key={index.toString()} cx={x} cy={y} r="4" fill={theme.shades.one} />
            ))}
        </svg>
    );
};
